import { Box, Button, Typography } from "@material-ui/core";
import React from "react";
import UserModal from "../../../../components/UserModal";
import {
  TwitterShareButton,
  FacebookShareButton,
  RedditShareButton
} from "react-share";
import TwitterIcon from "./icons/twitter";
import FacebookIcon from "./icons/facebook";
import RedditIcon from "./icons/reddit";
import useTranslate from "../../../../../../hooks/use-translate";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  icon: {
    color: `${theme.palette.grey[600]}!important`,
    transition: `color .3s`,
    "&:focus": {
      outline: `none`
    },
    "&:hover": {
      color: `#84817D!important`
    }
  },
  divide: {
    textTransform: "uppercase",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1.2rem!important",
    lineHeight: "1.6rem!important",
    letterSpacing: `1.5px`,
    fontWeight: 600,
    minHeight: `30px`,
    marginTop: theme.spacing(2),
    [theme.breakpoints.up(`sm`)]: {
      marginLeft: theme.spacing(-2.5),
      marginRight: theme.spacing(-2.5)
    },
    "&:before, &:after": {
      content: '" "',
      display: "block",
      flex: `1 1 auto`,
      height: `1px`,
      backgroundColor: theme.palette.grey[600]
    },
    "&:before": {
      marginRight: theme.spacing(1.5)
    },
    "&:after": {
      marginLeft: theme.spacing(1.5)
    }
  }
}));

export default function ShareModal({ open, close, shareData, copy }) {
  const t = useTranslate();
  const classes = useStyles();
  return (
    <UserModal
      open={open}
      onClose={close}
      enableClose
      autoHeight
      title={t("user.profile.section.referral.modal.title")}
      description={
        <Box display="flex" flexDirection="column">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <TwitterShareButton
              className={classes.icon}
              url={shareData.url}
              title={shareData.title}
              hashtags={["Airgraft2.0"]}
            >
              <TwitterIcon />
            </TwitterShareButton>
            <FacebookShareButton
              className={classes.icon}
              url={shareData.url}
              quote={shareData.text}
              title="Airgraft2.0"
            >
              <FacebookIcon />
            </FacebookShareButton>
            <RedditShareButton
              className={classes.icon}
              url={shareData.url}
              title={shareData.title}
            >
              <RedditIcon />
            </RedditShareButton>
          </Box>
          <div className={classes.divide}>
            {t("user.profile.section.referral.modal.tips")}
          </div>
        </Box>
      }
    >
      <Box
        mt={2}
        mb={{ xs: 4, sm: 1 }}
        display="flex"
        justifyContent="center"
        alignItems={{
          xs: "stretch",
          sm: "center"
        }}
        flexDirection={{
          xs: "column",
          sm: "row"
        }}
      >
        <Box
          mr={{ xs: 0, sm: 2 }}
          mb={{ xs: 2, sm: 0 }}
          alignSelf="center"
          maxWidth={{
            xs: `250px`,
            md: `210px`
          }}
        >
          <Typography variant="body2" align="center" noWrap>
            {shareData.prettyLink}
          </Typography>
        </Box>
        <Button onClick={copy} size="small" variant="contained" color="primary">
          {t("user.profile.section.referral.copy")}
        </Button>
      </Box>
    </UserModal>
  );
}
